import React, { FC } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { Stack, TextFieldProps, Tooltip } from '@mui/material';
import { SLabel, STextField } from './styles';
import { IMaskInput } from 'react-imask';

type Props = {
  leftName: string;
  leftLabel: string;
  rightLabel: string;
  rightName: string;
  startHint?: string;
  tooltip?: string;
  endHint?: string;
};

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const TextMaskCustom = (props: CustomProps) => {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={Number}
      thousandsSeparator=","
      onAccept={(value: any) => {
        onChange({ target: { name: props.name, value: value.replace(/\,/g, '') } });
      }}
    />
  );
};

const RHFGroupTextField: FC<Props & TextFieldProps> = ({
  leftName,
  rightName,
  rightLabel,
  leftLabel,
  startHint,
  tooltip,
  endHint,
  ...other
}) => {
  const { control } = useFormContext();

  return (
    <Stack direction="row" maxWidth="500px">
      {startHint && (
        <Tooltip title={tooltip || ''} arrow placement="top">
          <SLabel start>{startHint}</SLabel>
        </Tooltip>
      )}
      <Controller
        name={leftName}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <STextField
            startHint={!!startHint}
            endHint={!!endHint}
            firstInput
            {...field}
            {...other}
            error={!!error}
            helperText={error?.message}
            InputProps={{ inputComponent: TextMaskCustom as any }}
            placeholder={leftLabel}
            size="small"
          />
        )}
      />
      <Controller
        name={rightName}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <STextField
            startHint={!!startHint}
            endHint={!!endHint}
            firstInput={false}
            {...field}
            {...other}
            error={!!error}
            InputProps={{ inputComponent: TextMaskCustom as any }}
            helperText={error?.message}
            placeholder={rightLabel}
            size="small"
          />
        )}
      />
      {endHint && <SLabel start={false}>{endHint}</SLabel>}
    </Stack>
  );
};

export default RHFGroupTextField;
